import { useTranslation } from 'react-i18next';

const useIsRTL = () => {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.dir(i18n.resolvedLanguage) === 'rtl';
  return [t, isRtl];
};

export default useIsRTL;
